import {Component, OnInit} from '@angular/core';
import {AnalyticsService} from '@utils/services/analytics/analytics.service';
import {LeagueService} from '@core/services/league.service';
import {AppLeague} from '@shared/models/league';
import {EntityType} from '@lib/models/entity/entity-type';
import {LayoutService} from '@utils/services/layout/layout.service';

@Component({
  selector: 'app-league-transfers',
  templateUrl: './league-transfers.component.html',
  styleUrls: ['./league-transfers.component.scss']
})
export class LeagueTransfersComponent implements OnInit {
  league: AppLeague;
  entityType = EntityType.League;
  constructor(public layoutService: LayoutService,
              public leagueService: LeagueService,
              private analyticsService: AnalyticsService) {
  }

  ngOnInit(): void {
    this.league = this.leagueService.currentLeague;
  }

  public onSendPageView(): void {
    this.analyticsService.sendPageView();
  }
}
